import styled from 'styled-components';

import { TextButton } from '@xing-com/button';
import { mediaTiny } from '@xing-com/layout-tokens';
import { spaceXL, spaceL, space4XL, spaceXXL } from '@xing-com/tokens';
import { Headline } from '@xing-com/typography';

export const ContentSpacer = styled.div<{
  $isLoading: boolean;
}>`
  margin-top: ${spaceXL};
  margin-bottom: ${space4XL};

  ${({ $isLoading }) => ($isLoading ? 'min-height: 80vh;' : '')};
`;

export const StyledHeadline = styled(Headline)`
  margin-bottom: ${spaceXXL};

  @media ${mediaTiny} {
    margin-bottom: ${spaceL};
  }
`;

export const StyledTextButton = styled(TextButton)`
  padding: 0;
  margin-top: ${spaceL};
`;
